import Image from "core/assets/images/index";

const data = {
  Topics: [
    {
      image: Image.icon_green,
      title: "GoFood Web",
      link: "https://www.gojek.com/en-id/help/gofoodweb",
    },
    {
      image: Image.icon_green,
      title: "Safety and Emergency",
      link: "https://www.gojek.com/en-id/help/safety-emergency",
    },
    {
      image: Image.icon_green,
      title: "GoSend",
      link: "https://www.gojek.com/en-id/help/gosend",
    },
    {
      image: Image.icon_green,
      title: "Join as Our Partner",
      link: "https://www.gojek.com/en-id/help/mitra",
    },
    {
      image: Image.icon_green,
      title: "App Issue",
      link: "https://www.gojek.com/en-id/help/app-issue",
    },
    {
      image: null,
      title: "Gopay Pinjam",
      link: "https://www.gojek.com/en-id/help/gopaypinjam",
    },
    {
      image: Image.icon_green,
      title: "GoBox",
      link: "https://www.gojek.com/en-id/help/gobox",
    },
    {
      image: Image.icon_green,
      title: "GoRide",
      link: "https://www.gojek.com/en-id/help/goride",
    },
    {
      image: Image.icon_blue,
      title: "GoPulsa",
      link: "https://www.gojek.com/en-id/help/gopulsa",
    },
    {
      image: Image.icon_blue,
      title: "GoPay Coins",
      link: "https://www.gojek.com/en-id/help/gopay-coins",
    },
    {
      image: Image.goinvestasi,
      title: "GoInvestasi",
      link: "https://www.gojek.com/en-id/help/goinvestasi",
    },
    {
      image: Image.icon_red,
      title: "GoFood",
      link: "https://www.gojek.com/en-id/help/gofood",
    },
    {
      image: Image.icon_blue,
      title: "GoTagihan",
      link: "https://www.gojek.com/en-id/help/gotagihan",
    },
    {
      image: Image.icon_green,
      title: "Promo Issue",
      link: "https://www.gojek.com/en-id/help/promo",
    },
    {
      image: null,
      title: "Gopay Tabungan",
      link: "https://www.gojek.com/en-id/help/gopay-tabungan",
    },
    {
      image: Image.icon_green,
      title: "Chat",
      link: "https://www.gojek.com/en-id/help/chat",
    },
    {
      image: Image.icon_green,
      title: "My Account",
      link: "https://www.gojek.com/en-id/help/akun",
    },
    {
      image: Image.jago,
      title: "Jago",
      link: "https://www.gojek.com/en-id/help/jago",
    },
    {
      image: Image.icon_red,
      title: "GoShop",
      link: "https://www.gojek.com/en-id/help/goshop",
    },
    {
      image: Image.icon_blue,
      title: "GoPay Later",
      link: "https://www.gojek.com/en-id/help/gopaylater",
    },
    {
      image: Image.icon_blue,
      title: "GoPay",
      link: "https://www.gojek.com/en-id/help/gopay",
    },
    {
      image: Image.icon_green,
      title: "GoCart",
      link: "https://www.gojek.com/en-id/help/gocar",
    },
    {
      image: Image.icon_red,
      title: "GoMart",
      link: "https://www.gojek.com/en-id/help/gomart",
    },
    {
      image: Image.icon_red,
      title: "GoSend E-commerce",
      link: "https://www.gojek.com/en-id/help/gosend-e-commerce",
    },
    {
      image: Image.gobluebird,
      title: "GoBluebird",
      link: "https://www.gojek.com/en-id/help/gobluebird",
    },
  ],
};

export default data;
